module.exports = __webpack_public_path__ + "img/02.077fb651.jpg";